import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NkDatatableAbstractColumnComponent } from '../../datatable.utils';

@Component({
  selector: 'nk-text-tag-list-column',
  templateUrl: './text-tag-list-column.component.html',
  styleUrls: ['./text-tag-list-column.component.scss'],
  standalone: false,
})
export class TextTagListColumnComponent<T> extends NkDatatableAbstractColumnComponent<T> {
  public text$: Observable<string[] | null> = this.value$.pipe(
    map((value) => {
      if (value && value.row && value.prop) {
        const item = value.row[value.prop];
        if (Array.isArray(item)) {
          return item;
        }
      }
      return null;
    }),
  );
}
